// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /event/lineups-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeEventLineupsGetBody,
  typeEventLineupsGetOutput200,
} from "../../sdk/event/postEventLineupsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildEventLineupsGetQueryKey(
  payload: typeEventLineupsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`eventId:${JSON.stringify(payload.eventId)}`);
  return ["post:event:eventLineupsGet", "svc:events-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeEventLineupsGetOutput200,
    unknown,
    typeEventLineupsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useEventLineupsGet(
  payload: typeEventLineupsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildEventLineupsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postEventLineupsGet(payload),
    ...resolvedOptions,
  });
}
